import { Component, inject, input, signal } from "@angular/core";
import {
	CalendarErrorRecordItem,
	CalendarErrorUserDetails
} from "@modules/global-dashboard/models/global-dashboard-interface";
import { Router } from "@angular/router";
import { CalendarFilesHistoryService } from "@modules/calendar-setup-file-history/services/calendar-files-history.service";
import { UserRole } from "@shared/constants/roles";

import { FileManagementUploadService } from "@shared/services/file-management/file-management-upload.service";
import { ToastService } from "@shared/services/toast/toast.service";
import { take } from "rxjs";
import { AppState } from "@store/models/state.model";
import { Store } from "@ngrx/store";
import { getUserDataState } from "src/app/store";

@Component({
	selector: "app-calendar-actions",
	templateUrl: "./calendar-actions.component.html",
	styleUrls: ["./calendar-actions.component.scss"]
})
export class CalendarActionsComponent {
	openCalendarErrorSidePanel = signal<boolean>(false);
	calendarErrorRecords: CalendarErrorRecordItem[] = [];

	showCalendarErrorSidePanelButton = input<boolean>(false);

	readonly UserRole = UserRole;

	private router = inject(Router);
	private toastService = inject(ToastService);
	private fileManagementUploadService = inject(FileManagementUploadService);
	private calendarFilesHistoryService = inject(CalendarFilesHistoryService);
	private store = inject(Store<AppState>);

	constructor() {
		this.store
			.select(getUserDataState)
			.pipe(take(1))
			.subscribe(userData => {
				this.calendarErrorRecords = JSON.parse(
					localStorage.getItem("CALENDAR_ERROR_USER_DETAILS") || "[]"
				).find((item: CalendarErrorUserDetails) => item.email === userData.email)?.calendarErrorItems;
			});
	}

	showCalendarFiles(): void {
		this.router.navigateByUrl("/calendar/files");
	}

	uploadFile(event: Event, files: any): void {
		event.stopPropagation();

		try {
			const file: File = files[0];

			let formData = new FormData();
			formData.append("file", file);
			formData.append("fileType", "EXCEL");
			formData.append("sheetIndex", "0");
			formData.append("headerIndex", "0");

			this.fileManagementUploadService.uploadCalendarFile(formData);

			this.router.navigateByUrl("/calendar/files");
		} catch (error) {
			this.toastService.showError("There was an error loading the file. Please try again");
		}
	}

	downloadTemplate(): void {
		this.calendarFilesHistoryService
			.createCalendarReportTask()
			.pipe(take(1))
			.subscribe({
				next: _ => void 0,
				error: (err: any) => {
					if (err.name === "TimeoutError") {
						this.toastService.showError(
							"An error occured while trying to download the template. Please try again"
						);
					} else {
						switch (err.status) {
							case 200:
								this.toastService.showSuccess("Template download request successfully initiated!");
								this.router.navigateByUrl("/calendar/files");
								break;

							default:
								this.toastService.showError(
									"An error occured while trying to download the template. Please try again later"
								);
								break;
						}
					}
				}
			});
	}

	showCalendarErrorsSidePanel(): void {
		this.openCalendarErrorSidePanel.set(true);
	}
}
